import { AxiosRequestConfig } from 'axios'
import { Get } from './Get'
import { Post } from './Post'
import { Put } from './Put'
import { Patch } from './Patch'
import { CreateApiKeyDto, UpdateApiKeyDto } from './ApiKey.interface'
import { ApiHelpers, APIHosts } from './ApiHelpers'

class ApiKeyServiceController extends ApiHelpers {
  ApiHost = APIHosts.LicenseManager;

  private get licenseManagerUrl() {
    return this.getHost(this.ApiHost)
  }

  public Get = {
    getApiKeys: (
      servicePrincipalId: string,
      options: AxiosRequestConfig = {},
    ) => {
      return Get(
        `${this.licenseManagerUrl}/service-principals/${servicePrincipalId}/api-keys`,
        options,
      )
    },
    getClaims: (apiKeyId: string, options: AxiosRequestConfig = {}) => {
      return Get(`${this.licenseManagerUrl}/api-keys/${apiKeyId}/claims`, options)
    },
  }

  public Post = {
    createApiKey: (
      servicePrincipalId: string,
      data: CreateApiKeyDto,
      options: AxiosRequestConfig = {},
    ) => {
      return Post(
        `${this.licenseManagerUrl}/service-principals/${servicePrincipalId}/api-keys`,
        data,
        options,
      )
    },
    revoke: (apiKeyId: string, options: AxiosRequestConfig = {}) => {
      return Post(
        `${this.licenseManagerUrl}/api-keys/${apiKeyId}/revoke`,
        {},
        options,
      )
    },
  }

  public Patch = {
    updateApiKey: (
      apiKeyId: string,
      data: UpdateApiKeyDto,
      options: AxiosRequestConfig = {},
    ) => {
      return Patch(`${this.licenseManagerUrl}/api-keys/${apiKeyId}`, data, options)
    },
  }

  public Put = {
    replaceClaims: (
      apiKeyId: string,
      productClaimIds: string[],
      options: AxiosRequestConfig = {},
    ) => {
      return Put(
        `${this.licenseManagerUrl}/api-keys/${apiKeyId}/claims`,
        { productClaimIds },
        options,
      )
    },
  }
}

export const ApiKeyService = new ApiKeyServiceController()
